import React, { useEffect, useState } from "react";
import Head from "../../layout/head/Head";
import { useForm } from "react-hook-form";
import Content from "../../layout/content/Content";
import { Block, Col, DataTable, PreviewAltCard, Row } from "../../components/Component";
import { Form, Offcanvas, OffcanvasBody, OffcanvasHeader } from "reactstrap";

import { createMappingAPI, listMappingAPI, updateMappingAPI } from "../../api/master/indes";

import { toast } from "react-toastify";

import { BASE_URL_IMG } from "../../assets/constants";
import MyButton from "../../MyComp/UI/form/MyButton";
import ViewImage from "../../MyComp/UI/modals/ViewImage";
import ConfirmModal from "../../MyComp/UI/modals/ConfirmModal";
import MyInput from "../../MyComp/UI/form/MyInput";
import Status from "../../MyComp/UI/form/Status";
import useLogout from "../../hooks/useLogout";
import Table from "../../MyComp/UI/DataTable/Table";
import MySelect from "../../MyComp/UI/form/MySelect";
import { diseaseDDAPI, getsubqualificationDDAPI, qualificationDDAPI, specializationDDAPI } from "../../api/dropdown";

const DiseaseMapping = () => {
    const {
        register,
        handleSubmit,
        setValue,
        watch,
        trigger,
        formState: { errors },
    } = useForm({
        defaultValues: {
            isLoading: false,
            data: [],
            specializationDD: [],
            qualificationList: [],
            sub_qualificationList: [],
            isPub: false,
        },
    });
    const logout = useLogout();

    const [isOpen, setIsOpen] = useState(false);
    const [imageOpen, setImageOpen] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [mode, setMode] = useState("Add");
    const isLoading = watch("isLoading");
    const [data, setData] = useState([]);

    const toggleCanvas = () => {
        setIsOpen((prev) => !prev);
        if (isOpen) resetF();
    };

    const selectorCheck = (e) => {
        const updated = data.map((item) => ({ ...item, checked: e.target.checked }));
        setData(updated);
    };
    const handleTogglePublish = (row) => {
        setValue("isPub", true);
        setValue("selectedRow", row);
        setShowModal(true);
    };

    const selectorDeleteUser = () => setData(data.filter((d) => !d.checked));
    const handleImageOpenPreview = (row) => {
        setImageOpen(!imageOpen);
        setValue("image_preview", row);
        trigger("image_preview");
    };

    const handleImageClose = () => {
        setImageOpen(!imageOpen);
    };

    const onSelectChange = (e, id) => {
        const updated = data.map((item) => (item.id === id ? { ...item, checked: e.target.checked } : item));
        setData(updated);
    };

    useEffect(() => {
        getqualificationList();
        getSpecializationDD()
        getDiseaseDD()
    }, []);
    const selectorSuspendUser = () => setData(data.map((d) => (d.checked ? { ...d, status: false } : d)));


    const getqualificationList = () => {
        qualificationDDAPI()
            .then((res) => {
                if (res.data.status === true) {
                    console.log(res.data, "res.data");
                    setValue("qualificationList", res?.data?.data);
                } else if (res.data.status === false) {
                    setValue("qualificationList", []);
                    toast.error(res.data.message);
                } else if (res.data.status === "expired") {
                    toast.error(res.data.message);
                    logout();
                }
            })
            .catch((err) => toast.error(err.message));
    };

    const getSubqualificationList = async (qualificationId, index) => {
        try {
            const data = {
                id: qualificationId?.value || qualificationId
            }
            const res = await getsubqualificationDDAPI(data);
            if (res?.data?.status === true) {
                setValue(`sub_qualificationMap`, res.data.data);
            }
            else if (res?.data?.status === false) {
                setValue(`sub_qualificationMap`, []);

                setValue(`sub_qualifications`, "");
            }
            else if (res?.data?.status === "expired") {
                toast.error(res.data.message);
                logout();
            }
        } catch (err) {
            toast.error(err.message);
        }
    };


    const getSpecializationDD = () => {
        // return
        specializationDDAPI()
            .then((res) => {
                if (res.data.status === true) {
                    setValue("specializationDD", res.data.data);
                } else if (res.data.status === false) {
                    setValue("specializationDD", []);
                    toast.error(res.data.message);
                } else if (res.data.status === "expired") {
                    toast.error(res.data.message);
                    logout();
                }
            })
            .catch((err) => toast.error(err.message));
    };

    const getDiseaseDD = () => {
        // return
        diseaseDDAPI()
            .then((res) => {
                if (res.data.status === true) {
                    setValue("diseaseDD", res.data.data);
                } else if (res.data.status === false) {
                    setValue("diseaseDD", []);
                    toast.error(res.data.message);
                } else if (res.data.status === "expired") {
                    toast.error(res.data.message);
                    logout();
                }
            })
            .catch((err) => toast.error(err.message));
    };


    const onFormSubmit = () => {
        const qualification = watch("qualification") || [];
        const subQualifications = watch("sub_qualifications") || [];
        const specialization = watch("specialization") || [];
        const disease = watch("disease") || [];

        const qualificationValue = Array.isArray(qualification)
            ? qualification.map((q) => q.value)
            : qualification?.value || qualification;

        const subQualificationsValue = Array.isArray(subQualifications)
            ? subQualifications.map((sq) => sq.value)
            : subQualifications?.value || subQualifications;

        const specializationValue = Array.isArray(specialization)
            ? specialization.map((s) => s.value)
            : specialization?.value || specialization;

        const diseaseValue = Array.isArray(disease)
            ? disease.map((s) => s.value)
            : disease?.value || disease;

        const body = {
            qualification: qualificationValue,
            sub_qualification: subQualificationsValue,
            specialization: specializationValue,
            disease: diseaseValue,
            status: watch("status")?.value,
            ...(mode === "Edit" && { id: watch("selectedRow")?.id }),
        };

        console.log("Submit Payload ", body);

        const apiCall =
            mode === "Add" ? createMappingAPI(body) : updateMappingAPI(body);

        setValue("isLoading", true);

        apiCall
            .then((res) => {
                if (res.data.status === "expired") {
                    toast.error(res.data.message);
                    logout();
                } else if (res.data.status) {
                    toast.success(res.data.message);
                    toggleCanvas();
                    getMapping()
                } else {
                    toast.error(res.data.message);
                }
            })
            .catch((err) => toast.error(err?.response?.data?.message))
            .finally(() => setValue("isLoading", false));
    };

    useEffect(() => {
        getMapping();
    }, []);

    const getMapping = () => {
        setValue("isLoading", true);
        listMappingAPI()
            .then((res) => {
                if (res.data.status === "expired") {
                    toast.error(res.data.message);
                    logout();
                } else if (res.data.status === true) {
                    setData(res.data.data || []);
                } else {
                    setData([]);
                    toast.error(res.data.message);
                }
            })
            .catch((err) => toast.error(err?.response?.data?.message))
            .finally(() => setValue("isLoading", false));
    };
    const handleEdit = (row) => {
        window.scrollTo(0, 0);
        setValue("selectedRow", row);
        setValue("qualification", {
            label: row.qualification_name,
            value: row.qualification_id,
        });
        setValue("sub_qualifications", {
            label: row.subQualification_name,
            value: row.sub_qualification_id,
        });
        setValue("disease", {
            label: row.disease_name,
            value: row.disease_id,
        });

        setValue("specialization", {
            label: row.speciality_name,
            value: row.speciality_id,
        });

        setValue("status", {
            label: row.status ? "Active" : "Inactive",
            value: row.status,
        });

        setMode("Edit");
        setIsOpen(true);
    };


    const handleToggleStatus = (row) => {
        setValue("selectedRow", row);
        setShowModal(true);
    };

    const confirmStatusChange = () => {
        const updatedStatus = !watch("selectedRow").status;
        const body = { id: watch("selectedRow").id, status: updatedStatus };

        setValue("isLoading", true);

        updateMappingAPI(body)
            .then((res) => {
                if (res.data.status === "expired") {
                    toast.error(res.data.message);
                    logout();
                    getMapping()
                } else if (res.data.status) {
                    toast.success(res.data.message);

                    setShowModal(false);
                } else {
                    toast.error(res.data.message);
                }
            })
            .catch((err) => toast.error(err?.response?.data?.message))
            .finally(() => setValue("isLoading", false));
    };
    const resetF = () => {
        setValue("qualification", null);
        setValue("sub_qualifications", null);
        setValue("specialization", null);
        setValue("disease", null);
        setValue("status", "");
        setMode("Add");
    };
    return (
        <>
            <Head title={"Product | Master"} />
            <Content>
                <Block>
                    <>
                        {" "}
                        <div className="container my-5 text-center">
                            {/* Button to open offcanvas */}

                            <Offcanvas isOpen={isOpen} direction="end">
                                <OffcanvasHeader toggle={toggleCanvas}>Disease Mapping </OffcanvasHeader>
                                <OffcanvasBody>
                                    <PreviewAltCard>
                                        <Form onSubmit={handleSubmit(onFormSubmit)}>
                                            <Row>
                                                <Col md="12" className={``}>
                                                    <MySelect
                                                        register={register}
                                                        watch={watch}
                                                        trigger={trigger}
                                                        errors={errors}
                                                        name={`qualification`}
                                                        placeholder="Select Qualification"
                                                        options={watch("qualificationList")}
                                                        required
                                                        title="Qualification"
                                                        setValue={(name, value) => {
                                                            setValue(name, value);
                                                            getSubqualificationList(value?.value);
                                                        }}
                                                    />
                                                </Col>
                                                <Col md="12" className={``}>
                                                    <MySelect
                                                        register={register}
                                                        watch={watch}
                                                        setValue={(name, value) => {
                                                            setValue(name, value);
                                                        }}
                                                        trigger={trigger}
                                                        errors={errors}
                                                        name={`sub_qualifications`}
                                                        placeholder="Select Sub Qualification"
                                                        options={watch(`sub_qualificationMap`) || []}
                                                        title="Sub QualificationList"
                                                    // required
                                                    />
                                                </Col>
                                                <Col md="12" className={``}>
                                                    <MySelect
                                                        register={register}
                                                        watch={watch}
                                                        setValue={setValue}
                                                        trigger={trigger}
                                                        errors={errors}
                                                        title="Specialization"
                                                        name="specialization"
                                                        placeholder="Select specialization"
                                                        required
                                                        options={watch("specializationDD") || []}
                                                    // multi
                                                    />
                                                </Col>
                                                <Col md="12" className={``}>
                                                    <MySelect
                                                        register={register}
                                                        watch={watch}
                                                        setValue={setValue}
                                                        trigger={trigger}
                                                        errors={errors}
                                                        title="Disease"
                                                        name="disease"
                                                        placeholder="Select Disease"
                                                        required
                                                        options={watch("diseaseDD") || []}
                                                    // multi
                                                    />
                                                </Col>
                                                <Col md={`12`}>
                                                    <Status
                                                        register={register}
                                                        watch={watch}
                                                        setValue={setValue}
                                                        trigger={trigger}
                                                        errors={errors}
                                                    />
                                                </Col>
                                            </Row>
                                            <Col md="12" className={``}>
                                                <div className="form-group text-end" style={{ marginTop: "31px" }}>
                                                    <MyButton isLoading={isLoading} mode={mode} />
                                                </div>
                                            </Col>
                                        </Form>
                                    </PreviewAltCard>
                                </OffcanvasBody>
                            </Offcanvas>
                        </div>
                    </>

                    <Table
                        title="Disease Mapping List"
                        data={data}
                        publicButton={false}
                        columns={[
                            { key: "qualification_name", label: "Qualification" },
                            { key: "subQualification_name", label: "SubQualification" },
                            { key: "speciality_name", label: "Speciality" },
                            { key: "disease_name", label: "Disease" },
                        ]}
                        searchKeys={["disease_name",]}
                        nameColumn={"disease"}
                        imageBaseURL={BASE_URL_IMG}
                        onEditClick={handleEdit}
                        selectorCheck={selectorCheck}
                        selectorDeleteUser={selectorDeleteUser}
                        selectorSuspendUser={selectorSuspendUser}
                        onSelectChange={onSelectChange}
                        statusFilterEnabled={true}
                        isOpen={isOpen}
                        confirmStatusChange={confirmStatusChange}
                        setIsOpen={setIsOpen}
                        resetF={resetF}
                        handleImageOpenPreview={handleImageOpenPreview}
                        handleToggleStatus={handleToggleStatus}
                        toggleCanvas={toggleCanvas}
                        handleTogglePublish={handleTogglePublish}
                    />
                </Block>
            </Content>
            <ViewImage url={watch("image_preview")} imageOpen={imageOpen} handleImageClose={handleImageClose} />
            <ConfirmModal
                isOpen={showModal}
                toggle={() => {
                    setShowModal(!showModal);
                    setValue("isPub", false);
                }}
                onConfirm={confirmStatusChange}
                status={watch("selectedRow")?.status}
                isPub={watch("isPub")}
                data={watch("selectedRow")}
            />
        </>
    );
};

export default DiseaseMapping;
